module.exports = __webpack_public_path__ + "static/img/channel-3.94c80299.png";